import { createApp } from "vue";
// import * as Sentry from "@sentry/vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "@/assets/css/base.scss";
import router from "@/router/index";
import "@/router/permission";
import VueDOMPurifyHTML from "vue-dompurify-html";
const app = createApp(App);
/*
 * if (process.env.NODE_ENV === "production") {
 *   Sentry.init({
 *     app,
 *     dsn: "https://937d8dca5ac727bc6c8bb54871b83824@cloud-front.ebtech.com/3",
 *     integrations: [
 *       Sentry.browserTracingIntegration({ router }),
 *       Sentry.replayIntegration()
 *     ],
 *     tracesSampleRate: 1.0,
 *     tracePropagationTargets: [
 *       "localhost",
 *       /^https:\/\/console.ebtech-inc.com\/v1/,
 *       /^https:\/\/console.ebtech.com\/v1/,
 *     ],
 *     replaysSessionSampleRate: 0.1,
 *     replaysOnErrorSampleRate: 1.0
 *   });
 * }
 */
import { setupStore } from "@/store";
setupStore(app);
import { svgIcon } from "@/icons";
svgIcon(app);
// @ts-ignore
import MetaInfo from "vue-meta-info";
app.use(MetaInfo);
import directive from "@/directive/index";
directive(app);
app.use(router);
app.use(ElementPlus, {
    locale: zhCn
});
app.use(VueDOMPurifyHTML);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const debounce = (fn, delay) => {
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...rest) {
        const args = rest;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(args);
        }, delay);
    };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
};
app.mount("#app");
